
import React from "react";
import CustomButton from "../../components/common/CustomButton";
import CustomizableAvatar from "../../components/common/CustomizableAvatar";
import Smartlend from "../../assets/SMARTLEND.png";
import { Link } from "react-router-dom";
import Loading from "../../components/common/Loading";

const Home = () => {
  const [isLoading, setIsLoading] = React.useState(true);

  // loader
  React.useEffect(() => {
    const delay = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(delay);
  }, []);

  return (
    <main className="block w-full my-60 mx-auto">
      {isLoading ? (
        <Loading type="spokes" color="#4C4DDC" height={100} width={50} />
      ) : (
        <>
          <CustomizableAvatar
            src={Smartlend}
            customClass={"flex align-center justify-center"}
          />
          <section className="flex justify-center pt-7">
            <CustomButton className={"bg-th-bg mr-8 rounded "}>
              <Link className="text-enabled-btn px-10" to={"/login"}>
                Login
              </Link>
            </CustomButton>

            <CustomButton
              className={"bg-indigo-500 text-slate-50 border rounded"}
            >
              <Link className="px-8" to={"/signup"}>
                Sign Up
              </Link>
            </CustomButton>
          </section>
        </>
      )}
    </main>
  );
};

export default Home;



// Your code untouched
// import CustomButton from "../../components/common/CustomButton";
// import CustomizableAvatar from "../../components/common/CustomizableAvatar";
// import Smartlend from "../../assets/SMARTLEND.png";
// import { Link } from "react-router-dom";
// import { useSelector } from "react-redux";

// const Home = () => {
//   const pagesView = useSelector((state) => state.pagesView);
//   console.log(pagesView);
  
//   return (
//     <main className="block w-full my-60 mx-auto">
//       <CustomizableAvatar
//         src={Smartlend}
//         customClass={" flex align-center justify-center"}
//       />
//       <section className="flex  justify-center pt-7">
//         <CustomButton className={"bg-th-bg mr-8 rounded "}>
//           <Link className="text-enabled-btn px-10" to={"/login"}>
//             Login
//           </Link>
//         </CustomButton>

//         <CustomButton className={"bg-indigo-500 text-slate-50 border rounded"}>
//           <Link className=" px-8" to={"/signup"}>
//             Sign Up
//           </Link>
//         </CustomButton>
//       </section>
//     </main>
//   );
// };

// export default Home;

